
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import GTCHome from './GTCHome';
import GTCChannel from './GTCChannel';

import GTCLogin from './GTCLogin';
import GTCRegister from './GTCRegister';
import GTCTwoFactor from './GTCTwoFactor';
import GTCForgot from './GTCForgot';

import GTCSubscriptionPlans from './GTCSubscriptionPlans';
import GTCSingleSubscription from './GTCSingleSubscription';
import GTCSubscriptions from './GTCSubscriptions';
import GTCService from './GTCService';
function PageRoutes() {
    return (
        <Routes>
            <Route path='/home' index element={<GTCHome />}/>
            

            <Route path='/login' element={<GTCLogin />}/>
            <Route path='/register' element={<GTCRegister />}/>
            <Route path='/verify' element={<GTCTwoFactor />}/>
            <Route path='/forgot' element={<GTCForgot />}/>
            <Route path='/subscriptions' element={<GTCSubscriptions />} />
            <Route path='/service/:service' element={<GTCService />} />
            <Route path='/service/:service/channel/:id' element={<GTCChannel />}/>

            <Route path='/service/:service/channel/:id/subscriptions' element={<GTCSubscriptionPlans />}/>
            <Route path='/service/:service/channel/:id/subscriptions/:plan' element={<GTCSingleSubscription />}/>
        </Routes>
    );
}

export default PageRoutes;